<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/jHvvNI/tc-custom/9780312871727.jpg?1733084687471" alt="This image is the cover for the book Gone to Texas"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Gone to Texas
      </h1>
      <p class="bookDescription body article font2">
        <p>Peyton Lewis and Fletcher Rucker are two humble Rebel boys whose innocence was destroyed in the bloody wreckage of the Civil War. Young and desperate, they fall in with a scheme to rob a bank but are totally unprepared for the violence that ensues. Sickened by the carnage and wanton cruelty that they have witnessed, Lewis and Rucker take their cut and join the migration of those who see the possibility of a new beginning in the wilderness of the Texas frontier.<br/><br/>Along the way they meet rogues, killers...and two exceptional women: the tortured Molly Klinner, a woman who has also suffered dearly by the ravages of the war, and Gabriel Johnson, an Eastern beauty who decided to join the Texas migration on a lark--but will soon learn the true meaning of humanity. Together, the four travelers will weather the travails that the new frontier offers them--but will they manage to carve out a new life?<br/><br/>At the Publisher's request, this title is being sold without Digital Rights Management Software (DRM) applied.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Don Wright
      </h2>
      
      <p class="authorDescription body article"><P>Don Wright is the author of <I>Gone to Texas.</I></P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Tom Doherty Associates
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4f8f139b